import './index.css';
import 'url-search-params-polyfill';
import { BrowserRouter } from 'react-router-dom';
import { createLogger } from 'redux-logger';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { setAuthToken } from './actions';
import { unregister } from './registerServiceWorker';
import AppContainer from './components/App';
import Auth from './auth';
import React from 'react';
import ReactDOM from 'react-dom';
import reducer from './reducers/index';
import * as Sentry from '@sentry/browser';
import thunkMiddleware from 'redux-thunk';
import Util from 'utilities';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
});

const appleTouchIconSizes = [57, 60, 72, 76, 114, 120, 144, 152, 180, 192];
appleTouchIconSizes.map(size => {
  Util.createAndAppendIconLink('apple-touch-icon', size);
  return size;
});

const iconSizes = [16, 32, 96, 192];
iconSizes.map(size => {
  Util.createAndAppendIconLink('icon', size);
  return size;
});

function promiseMiddleware(next) {
  return action => {
    return action && typeof action.then === 'function' ? action.then(next) : next(action);
  };
}

const store = createStore(reducer, applyMiddleware(createLogger()), applyMiddleware(thunkMiddleware), applyMiddleware(promiseMiddleware));

// Set the auth token
const token = Auth.getLoginCookie();
if (token !== undefined) {
  store.dispatch(setAuthToken(token));
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <AppContainer />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// registerServiceWorker();

unregister();
